<template>
    <div>
      <h2 class="col-lg-12 text-center mb-3">{{ $t('add') }}</h2>
      <MembersForm @submit-requested="submitRequested"></MembersForm>
    </div>
  </template>
   
  <script>
  import { mapActions } from 'vuex'
  import MembersForm from './MembersForm.vue'
  
    export default {
    components: { MembersForm },
    methods: {
      ...mapActions('members', ['postMember']),
      submitRequested (input) {
        this.postMember(input);
      },
    }
  }
  </script> 
   
  <style scoped>
  thead > tr > th
  {
    text-align: unset !important;
  }
  </style> 